import React from 'react'
import { useTranslation } from 'react-i18next'

import { ResidentAppIllustration } from 'components/ResidentAppIllustration'
import Success from 'components/Success'

export const DefectNoticeSuccess: React.FC<{ editMode: boolean }> = ({
  editMode,
}) => {
  const { t } = useTranslation(['common', 'defectNotice'])

  return (
    <Success
      illustration={
        <ResidentAppIllustration
          name="house-maintenance"
          alt={t('defectNotice:alt.successIllustration')}
          className="-ml-2"
        />
      }
      heading={t('common:thankYou')}
      text={
        editMode
          ? t('common:editFormSent', {
              form: t('defectNotice:headings.success'),
            })
          : t('common:formSent', {
              form: t('defectNotice:headings.success'),
            })
      }
    />
  )
}
